import { IonButtons, IonMenuButton, IonTitle, IonToolbar, IonBackButton, IonIcon, IonImg } from '@ionic/react';
import './InnerMenu.css';
import { useContext } from 'react';
import { ActionType, AuthContext } from '../context/AuthContext';
import { localStore } from '../App';

interface ContainerProps {
  name: string;
  userType?: string
  isLogoutVisible?: boolean
}
const InnerMenu: React.FC<ContainerProps> = ({ name, userType = '', isLogoutVisible = false }) => {

  const { dispatch } = useContext(AuthContext)

  const handleLogout = async () => {
    await localStore.remove('user')
    await dispatch({ type: ActionType.SET_USER, payload: null })
  }

  return (
    <IonToolbar>
      <IonButtons slot="start">
        {/* <IonBackButton /> */}
      </IonButtons>
      <IonImg class="toolbarImages ion-margin ion-margin-start" slot="start" alt="Logo portolano del Po" src={`${process.env.PUBLIC_URL}/assets/images/PortolanoPo-28.png`} />
      {isLogoutVisible &&
        <IonButtons slot="end" onClick={handleLogout}>
          <IonIcon slot='icon-only' icon={`${process.env.PUBLIC_URL}/assets/images/logout.svg`}></IonIcon>
        </IonButtons>
      }
      <IonButtons slot="end">
        <IonMenuButton class="ion-margin-end">
          <IonIcon src={`${process.env.PUBLIC_URL}/assets/images/portolanoPo-menu.svg`}></IonIcon>
        </ IonMenuButton>
      </IonButtons>
    </IonToolbar>
  );
};

export default InnerMenu;
